module.exports = __webpack_public_path__ + "media/src/images/buttons/email-b4950d62f2f58d52ebac087e67f16406.svg";